import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import { Link } from 'react-router-dom';
import CartItem from './CartItem';
import CartModal from './CartModal';
import { ProductContext } from 'context/Context';
import { changeToCoin } from 'helpers/utils'; // getSubtotal

const ShoppingCart = () => {
 const [totalCost, setTotalCost] = useState(0);
 const [promoCode, setPromoCode] = useState('');

 const getSubtotal = items => items.reduce((acc, curr) => curr.totalPrice + acc, 0);

 const {
  productsState: { cartItems },
  productsDispatch
 } = useContext(ProductContext);

 useEffect(() => {
  setTotalCost(getSubtotal(cartItems));
 }, [cartItems]);

 const applyPromo = e => {
  e.preventDefault();
  productsDispatch({
   type: 'APPLY_PROMO',
   payload: {
    promoCode
   }
  });
  setPromoCode('');
 };

 return (
  <>
   <Card>
    <Card.Header>
     <Row className="justify-content-between">
      <Col md="auto">
       <h5 className="mb-3 mb-md-0">Carrito de compra ({cartItems.length} artículos)</h5>
      </Col>
      <Col md="auto">
       <IconButton
        className="border-300 me-2"
        iconClassName="me-1"
        variant="outline-secondary"
        size="sm"
        icon="chevron-left"
        transform="shrink-4"
        as={Link}
        to="/products/grid"
       >
        Seguir comprando
       </IconButton>
       <Button as={Link} to="/e-commerce/checkout" variant="primary" size="sm">
        Checkout
       </Button>
      </Col>
     </Row>
    </Card.Header>
    <Card.Body className="p-0">
     {cartItems.length > 0 ? (
      <>
       <Row className="gx-card mx-0 bg-200 text-900 fs-10 fw-semibold">
        <Col xs={9} md={8} className="py-2">
         Nombre
        </Col>
        <Col xs={3} md={4}>
         <Row>
          <Col md={8} className="py-2 d-none d-md-block text-center">
           Cantidad
          </Col>
          <Col xs={12} md={4} className="text-end py-2">
           Precio
          </Col>
         </Row>
        </Col>
       </Row>
       {cartItems.map((product, i) => (
        <CartItem key={i} product={product} />
       ))}
       <Row className="fw-bold gx-card mx-0">
        <Col xs={9} md={8} className="py-2 text-end text-900">
         Total
        </Col>
        <Col className="px-0">
         <Row className="gx-card mx-0">
          <Col md={7} className="py-2 d-none d-md-block text-center">
           {cartItems.length} (artículos)
          </Col>
          <Col xs={12} md={5} className="text-end py-2 text-nowrap px-x1">
           {changeToCoin({ amount: totalCost, symbol: true, cents: true })}
          </Col>
         </Row>
        </Col>
       </Row>
      </>
     ) : (
      <p className="p-x1 mb-0 bg-body-tertiary">
       No tienes ningún artículo en tu carrito de compras. ¡Continúa y comienza a comprar!
      </p>
     )}
    </Card.Body>

    {cartItems.length > 0 && (
     <Card.Footer className="bg-body-tertiary d-flex justify-content-end">
      <Form className="me-3" onSubmit={applyPromo}>
       <div className="input-group input-group-sm">
        <Form.Control type="text" placeholder="GET50" value={promoCode} onChange={e => setPromoCode(e.target.value)} />
        <Button variant="outline-secondary" size="sm" className="border-300" type="submit">
         Aplicar
        </Button>
       </div>
      </Form>
      <Button as={Link} to="/e-commerce/checkout" variant="primary" size="sm">
       Checkout
      </Button>
     </Card.Footer>
    )}
   </Card>
   <CartModal />
  </>
 );
};

export default ShoppingCart;
